'use client';

import { useEffect, useState } from 'react';
import { Box, IconButton } from '@mui/material';
import { isFalsy } from 'utility-types';
import { getUserStores } from '@/api/appuser.api';
import { getTeamInfobyOgranizationId } from '@/api/organization.api';
import { useFavoriteStore } from '@/stores/favoriteStore.store';
import { useOrganizationTeamStore } from '@/stores/organizationTeam.store';
import { getToken } from '@/utils/auth.util';
import FlexBox from '@/components/FlexBox';
import theme from '@/app/theme';
import { HeaderLogo } from '@/shared/ui/atoms';
import MobileSideBar from './MobileSideBar';

const Hamburger = ({ isActive = false }: { isActive?: boolean }) => {
  return (
    <>
      <Box
        sx={{
          width: '20px',
          display: 'flex',
          flexDirection: 'column',
          gap: '4px'
        }}
      >
        <Box
          sx={{
            display: 'inline-block',
            transition: 'all 0.4s',
            boxSizing: 'border-box',
            backgroundColor: theme.palette.gray[600],
            height: '2px',
            transform: isActive ? 'translateY(7px) rotate(-45deg)' : ''
          }}
        />
        <Box
          sx={{
            display: 'inline-block',
            transition: 'all 0.4s',
            boxSizing: 'border-box',
            backgroundColor: theme.palette.gray[600],
            height: '2px',
            opacity: isActive ? 0 : 1
          }}
        />
        <Box
          sx={{
            display: 'inline-block',
            transition: 'all 0.4s',
            boxSizing: 'border-box',
            backgroundColor: theme.palette.gray[600],
            height: '2px',
            transform: isActive ? 'translateY(-5px) rotate(45deg)' : ''
          }}
        />
      </Box>
    </>
  );
};

const MobileHeader = () => {
  const [IsUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [showSideBar, setShowSideBar] = useState(false);
  const { setAppUserStoreInfo } = useFavoriteStore();
  const { setTeams, setOrganizations } = useOrganizationTeamStore();

  const toggleDrawer = () => setShowSideBar(!showSideBar);

  useEffect(() => {
    const checkToken = async () => {
      const token = getToken();
      const isLoggedIn = !isFalsy(token?.accessToken);
      setIsUserLoggedIn(isLoggedIn);

      if (isLoggedIn) {
        try {
          const storesResult = await getUserStores();
          if (!storesResult.isSuccess || !storesResult.data) {
            console.error('조직 정보 조회 실패:', storesResult.message);
            return;
          }

          if (storesResult.data.organizationAppUserInfo?.[0]?.status === 'TEMPORARY') {
            return;
          }

          const { appUserStoreInfo, organizationAppUserInfo } = storesResult.data;
          if (appUserStoreInfo) {
            setAppUserStoreInfo(appUserStoreInfo);
          }

          if (organizationAppUserInfo?.length === 0) {
            return;
          }

          if (organizationAppUserInfo && organizationAppUserInfo?.[0]?.status !== 'TEMPORARY') {
            setOrganizations(organizationAppUserInfo);
            setTeams(organizationAppUserInfo[0]?.teamAppUserStoresInfo ?? []);
            if (organizationAppUserInfo[0]?.organizationRole !== 'ORGANIZATION_USER') {
              const teamResult = await getTeamInfobyOgranizationId(organizationAppUserInfo[0].organizationId);
              if (!teamResult.isSuccess || !teamResult.data) {
                console.error('조직 팀 정보 조회 실패:', teamResult.message);
                return;
              } else {
                setTeams(teamResult.data);
              }
            }
          }
        } catch (error) {
          console.error('병원 정보 조회 중 오류:', error);
        }
      }
    };
    checkToken();
  }, []);

  return (
    <>
      <FlexBox style={{ width: '100%', justifyContent: 'space-between', alignItems: 'center', overflow: 'visible' }}>
        <HeaderLogo IsUserLoggedIn={IsUserLoggedIn} />
        <IconButton sx={{ padding: 0, flexShrink: 0 }} onClick={toggleDrawer} aria-label={showSideBar ? '메뉴 닫기' : '메뉴 열기'} aria-expanded={showSideBar}>
          <Hamburger isActive={showSideBar} />
        </IconButton>
      </FlexBox>
      <MobileSideBar showSideBar={showSideBar} toggleDrawer={toggleDrawer} IsUserLoggedIn={IsUserLoggedIn} />
    </>
  );
};

export default MobileHeader;
